export { Progress } from '@chakra-ui/react';

export * from './Progress.theme';
